import { Component, OnInit, Input } from "@angular/core";
import { AppService } from "src/app/app.service";

@Component({
  selector: "app-value-renderer",
  templateUrl: "./value-renderer.component.html",
  styleUrls: ["./value-renderer.component.scss"],
})
export class ValueRendererComponent {
  @Input() value: number;
  @Input() precision: number;
  @Input() cut?: string = "";
  @Input() unit?: string = "";
  @Input() isInferred?: string = undefined;
  @Input() isPercentChange?: boolean = false;
  percentSymbol: string;
  formatedValue: string;
  inferredValue = false;
  isUnitPercent: string[] = ["%", "percent"];

  constructor(private appService: AppService) {}

  ngOnChanges() {
    this.inferredValue =
      this.isInferred !== undefined && Number(this.isInferred.charAt(0)) > 0
        ? true
        : this.inferredValue;
    if (this.value === undefined || this.value === null) {
      this.formatedValue = "";
      return;
    }
    if (this.value.toString() === "NM") {
      this.formatedValue = "NM";
      return;
    }
    this.formatedValue = this.appService.formatValue(
      Number(this.value),
      Number(this.precision),
    );
    if (this.isUnitPercent.includes(this.unit && this.unit.toLowerCase())) {
      this.percentSymbol = "%";
    } else if (this.unit === "bps") {
      this.percentSymbol = this.unit;
    }
  }
}
